import { render } from "./IconTurnOff.vue?vue&type=template&id=543ec542"
import script from "./IconTurnOff.vue?vue&type=script&lang=js"
export * from "./IconTurnOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__